import React from "react";
import "../CSS/WhyChoose.css";
import { FaCheck } from "react-icons/fa";

const WhyChoose = () => {

  return (
    <div className="why-container">
          <div className="why-left">
            <div className="img-top">
              <img src="/assets/banner113.png" alt="Doctors meeting" />
            </div>
          </div>
    
          <div className="why-right">
            <h2>Why Choose Tibi Smart?</h2>
            <ul>
              <li><FaCheck className="why-icon" />  Pencatatan Lebih Mudah & Cepat</li>
              <li><FaCheck className="why-icon" />  Monitoring Pasien Terpusat</li>
              <li><FaCheck className="why-icon" />  Analisis Sebaran Kasus (GIS)</li>
              <li><FaCheck className="why-icon" />  Mempermudah Koordinasi</li>
              <li><FaCheck className="why-icon" />  Data Aman & Terbatas</li>
              <li><FaCheck className="why-icon" />  Mendukung Pengambilan Keputusan</li>
            </ul>
          </div>
        </div>
    
  );
};

export default WhyChoose;
